import type { StateCreator } from 'zustand/vanilla';
import type { FeedDetailConfig, ThumbScrollListProps } from '@/app/types';

type FeedDetailStoreConfig = Omit<FeedDetailConfig, 'thumbScrollListConfig'> & {
  thumbScrollListConfig?: Pick<ThumbScrollListProps, 'hasMore' | 'list' | 'onLoadMore'>;
};

export type State = {
  /** FeedDetail 配置 */
  feedDetailConfig: FeedDetailStoreConfig | null;
};

export interface FeedDetailConfigStore extends State {
  /** 同步外部状态到弹窗 */
  syncFeedDetailConfig: (config: FeedDetailStoreConfig) => void;
  /** 还原 WorkDetail 配置 */
  resetFeedDetailConfig: () => void;
}

const initialState: State = {
  feedDetailConfig: null,
};

export const createFeedDetailConfigSlice: StateCreator<State, [], [], FeedDetailConfigStore> = (set) => ({
  ...initialState,

  syncFeedDetailConfig: (feedDetailConfig) => {
    set((state) => ({
      ...state,
      feedDetailConfig: { ...state.feedDetailConfig, ...feedDetailConfig },
    }));
  },

  resetFeedDetailConfig: () => {
    set(initialState);
  },
});
